<script setup lang="ts">
import ActionButton from '@/components/Elements/Buttons/ActionButton.vue'
import AlertBox from '@/components/Elements/Alerts/AlertBox.vue'
import TutorialFrame from '@/components/Interface/Modal/Modals/Tutorial/TutorialFrame.vue'
import { computed } from 'vue'
import { useRoute, useRouter } from 'vue-router'
import GenericIcon from '@/components/Elements/Images/Icons/GenericIcon.vue'
import { handleNext } from '../tutorialSteps'
import { useI18n } from 'vue-i18n'

const { t } = useI18n()
const route = useRoute()
const router = useRouter()

const handleNextStep = async () => {
  await handleNext('tutorial_planet_population')
}

const isOnPlanetsSection = computed(() => {
  return route.path.startsWith('/planets')
})

const goToPlanets = () => {
  router.push('/planets')
}

</script>

<template>
  <TutorialFrame
    video-url="https://cdn.ferion.com/videos/advisors/temperate/planet.webm"
  >
    <template #text>
      <p class="pb-2">
        {{ t('tutorial.planetPopulation.lifeblood') }}
      </p>
      <p class="pb-2">
        <i18n-t keypath="tutorial.planetPopulation.morePopulation" tag="span">
          <template #foodIcon><GenericIcon type="food" /></template>
        </i18n-t>
      </p>
      <p class="pb-2">
        <i18n-t keypath="tutorial.planetPopulation.assignWork" tag="span">
          <template #foodIcon><GenericIcon type="food" /></template>
          <template #productionIcon><GenericIcon type="production" /></template>
          <template #scienceIcon><GenericIcon type="science" /></template>
        </i18n-t>
      </p>
    </template>

    <template #alerts>
      <AlertBox type="info" class="mb-2">
        <i18n-t keypath="tutorial.planetPopulation.clickStats" tag="span">
          <template #foodIcon><GenericIcon type="food" /></template>
          <template #productionIcon><GenericIcon type="production" /></template>
          <template #scienceIcon><GenericIcon type="science" /></template>
        </i18n-t>
      </AlertBox>
    </template>

    <template #buttons>
      <ActionButton v-if="!isOnPlanetsSection" @click="goToPlanets" class="mr-2">
        {{ t('tutorial.planetPopulation.gotoPlanets') }}
      </ActionButton>
      <ActionButton @click="handleNextStep">
        {{ t('tutorial.planetPopulation.gotIt') }}
      </ActionButton>
    </template>
  </TutorialFrame>
</template>

<style scoped lang="scss"></style>